<template>
  <div id="form-page">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/accounting/journal">Journal</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doSubmit()" class="list-group">
        <b-row>
          <b-col md="5">
            <label class="labels">Transaction Number</label>
            <div class="form-group w-50 d-flex">
              <input
                type="text"
                class="form-control"
                v-model="model.journalNumberTransaction"
                placeholder="Journal Number Transaction"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"> </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label for="" class="labels">Date</label>
            <div class="form-group w-50">
              <b-form-datepicker
                class="form-control"
                v-model="model.journalDate"
              ></b-form-datepicker>
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"></b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label for="" class="labels">Note</label>
            <b-textarea class="form-group" v-model="model.journalNote"></b-textarea>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"></b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="12" class="mt-3">
            <div class="table-responsive  ml-2">
              <table>
                <thead>
                  <tr class="small-text border-bottom py-5">
                    <th>Account*</th>
                    <th>Note</th>
                    <th class="text-center">Debit</th>
                    <th class="text-left ml-1"><p class="mt-3 ml-4">Credit</p></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(selectedItem, index) in selectedItems">
                    <tr v-if="!selectedItem.isDeleted" :key="selectedItem.uuid">
                      <td width="400">
                        <b-form-input
                          v-model="selectedItem.name"
                          :plaintext="selectedItem.isCustomItem"
                          required
                          class="selected "
                          placeholder="Enter Item"
                        />
                      </td>

                      <td width="300">
                        <b-form-input
                          v-model="selectedItem.note"
                          :plaintext="selectedItem.isCustomItem"
                          class="selected small-text form-control"
                          type="text"
                          placeholder="Note ..."
                        ></b-form-input>
                      </td>
                      <td width="150">
                        <b-form-input
                          v-model="selectedItem.debit"
                          :plaintext="selectedItem.isCustomItem"
                          type="number"
                          required
                          class="text-center selected small-text"
                          placeholder="Debit"
                        />
                      </td>
                      <td width="150">
                        <b-form-input
                          v-model="selectedItem.credit"
                          :plaintext="selectedItem.isCustomItem"
                          type="number"
                          required
                          class="text-center selected small-text"
                          placeholder="Credit"
                        />
                      </td>
                      <td class="text-center">
                        <b-button
                          pill
                          v-b-tooltip.hover.right
                          title="Delete Row"
                          style="margin-bottom:5px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important; margin-left: 18px;"
                          size="sm"
                          variant="danger"
                          @click="() => deleteFromSelectedItems(index)"
                        >
                          x
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-dropdown text="Add Item" variant="dark">
              <div
                style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
              >
                <v-select
                  multiple
                  v-model="selectedItems"
                  style="width: 100%;"
                  id="mySelect"
                  label="name"
                  @input="addToSelected(availableItem.uuid)"
                  :options="list.accountData"
                  :reduce="(uuid) => uuid"
                  class="style-chooser mt-1"
                  placeholder="Type to search Items"
                ></v-select>
                <b-dropdown-divider></b-dropdown-divider>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>

        <b-row>
          <b-col></b-col>
          <b-col>
            <div class="w-75 d-flex float-right mr-5">
              <div>
                <b-form-input :value="formatNumber(countTotalDebit())" readonly>
                </b-form-input>
                <p>Total Debit</p>
              </div>
              <div class="ml-3">
                <b-form-input readonly :value="formatNumber(countTotalCredit())"></b-form-input>
                <p>Total Credit</p>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-5 mb-5">
          <b-col md="4">
            <div class="mt-3">
              <b-button class="mr-2 btn-md" @click="goBack()" variant="secondary"
                ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
              >
            </div>
          </b-col>
          <b-col md="4"></b-col>
          <b-col md="4">
            <div v-if="loadingButton" class="float-right mt-4">
              <b-button variant="warning" disabled>
                <b-spinner small type="grow"></b-spinner>
                Loading...
              </b-button>
            </div>
            <div v-else>
              <b-button variant="warning" class="btn-back float-right mt-3" type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon> Edit</b-button
              >
            </div>
          </b-col>
        </b-row>
      </form>
    </b-card>
  </div>
</template>

<script>
import RowEditJournalName from './RowEditJournalName.vue';
export default {
  components: { RowEditJournalName },
  data() {
    return {
      editJournal: false,
      index: 0,
      loadingButton: false,
      isCustomItem: false,
      isDeleted: false,
      selectedItems: [],
      availableItems: [],
      apiUrl: {
        account: window.AppConfig.apiUrl + 'journal-account',
        journal: window.AppConfig.apiUrl + 'journal',
      },
      model: {
        journalNumberTransaction: '',
        journalNote: '',
        journalDate: '',
        journalTransaction: [],
        accountNameSelected: '',
        accountUuid: '',
      },
      journal: {
        uuid: '',
        accountName: '',
        note: '',
        creditJournal: 0,
        debitJournal: 0,
      },
      list: {
        selectedAccount: '',
        accountData: [],
      },
      listJournal: [],
      allJournals: [],
      totalDebit: 0,
      totalCredit: 0,
    };
  },

  mounted() {
    this.initData();
    this.fetchJournalAccount();
    // this.countTotalDebit()
  },
  methods: {
    doSubmit() {
      this.loadingButton = true;
      const toSubmit = this.selectedItems.map((selectedItem) => ({
        uuid: selectedItem.uuid ? selectedItem.uuid : '',
        journalAccount: selectedItem.isCustomItem
          ? ''
          : selectedItem.journalUuid || selectedItem.journalUuid,
        journalNote: selectedItem.note,
        journalDebit: selectedItem.debit ? selectedItem.debit : 0,
        journalCredit: selectedItem.credit ? selectedItem.credit : 0,
        delete: selectedItem.isDeleted ? 1 : 0,
      }));
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('journalNumberTransaction', this.model.journalNumberTransaction);
          formData.append('journalDate', this.model.journalDate);
          formData.append('journalNote', this.model.journalNote);
          formData.append('journalTransaction', JSON.stringify(toSubmit));
          console.log(toSubmit);
          this.$http
            .patch(this.apiUrl.journal + '/' + this.$route.params.uuid, formData)
            .then((response) => {
              this.$store.dispatch('notification/success', 'Journal has been Updated');
              window.location.href = document.URL.replace('/edit', '');
            })
            .catch((error) => {
              this.loadingButton = false;
              this.$store.dispatch('notification/error', error);
            });
        } else {
          // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
          this.loadingButton = false;
        }
      });
    },

    initData() {
      if (this.$route.params.uuid !== undefined) {
        this.getJournalDetail();
      }
    },

    editJournalButton(value) {
      if (value) this.editJournal = !this.editJournal;
      this.$emit;
    },

    /**
     * @function fetchDetailsDeliveryOrder
     *
     * fetch data for view to form edit
     */
    getJournalDetail() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.journal + '/' + this.$route.params.uuid)
        .then((response) => {
          this.model.journalNumberTransaction = response.data.journalNumberTransaction;
          this.model.journalNote = response.data.journalNote;
          this.model.journalDate = this.getDate(response.data.journalDate);
          response.data.journalTransaction.forEach((data) => {
            this.listJournal.push({
              credit: data.journalTransactionCredit,
              debit: data.journalTransactionDebit,
            });
          });
          if (response.data.journalTransaction) {
            this.selectedItems = response.data.journalTransaction.map((selectedItem) => {
              console.log('journal', selectedItem);
              const journalName = selectedItem.journalAccount.journalAccountName;
              const countDebit = selectedItem.journalTransactionDebit;
              const countCredit = selectedItem.journalTransactionCredit;
              return {
                uuid: selectedItem.uuid ? selectedItem.uuid : '',
                journalUuid: selectedItem.journalAccount ? selectedItem.journalAccount.uuid : '',
                name: journalName,
                note: selectedItem.journalTransactionNote,
                credit: selectedItem.journalTransactionCredit,
                debit: selectedItem.journalTransactionDebit,
                isDeleted: false,
                isNewItem: false,
              };
            });
          }
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
        });
    },

    fetchJournalAccount() {
      this.$http.get(this.apiUrl.account + '?journalAccountType=D').then((response) => {
        this.list.accountData = [];
        response?.data?._embedded?.journal_account?.forEach((data) => {
          this.list.accountData.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountName,
          });
        });
      });
    },

    countTotalDebit() {
      let debitTotal = 0;
      this.listJournal.forEach(({ debit }) => {
        debitTotal = debitTotal + debit;
      });
      return debitTotal;
    },

    countTotalCredit() {
      let creditTotal = 0;
      this.selectedItems.forEach(({ credit }) => {
        creditTotal = creditTotal + credit;
      });
      return creditTotal;
    },

    /**
     * @function fetchJournalAccount
     * @async
     *
     */
    fetchJournalAccount: async function() {
      const response = await this.$http.get(this.apiUrl.account + '?journalAccountType=D');
      this.list.accountData = response.data._embedded.journal_account.map((availableItem) => ({
        journalUuid: availableItem.uuid,
        name: availableItem.journalAccountCode + ' ' + availableItem.journalAccountName,
        isCustomItem: false,
        isDeleted: false,
        isNewItem: true,
      }));
    },

    countTotalDebit() {
      let debitTotal = 0;
      this.selectedItems.forEach(({ debit }) => {
        debitTotal = debitTotal + parseInt(debit);
      });
      return debitTotal;
    },

    countTotalCredit() {
      let creditTotal = 0;
      this.selectedItems.forEach(({ credit }) => {
        creditTotal = creditTotal + parseInt(credit) ;
      });
      return creditTotal;
    },

    deleteSelectedItem() {
      (this.journal.debitJournal = 0),
        (this.journal.creditJournal = 0),
        (this.journal.note = ''),
        (this.model.accountNameSelected = '');
    },

    /**
     * @function addToSelected
     * @param {{ isCustomItem,note, name, debit, credit, uuid, isDeleted, isNewItem }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push({ ...item });
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        credit: 0,
        debit: 0,
        note: '',
        isCustomItem: true,
        isDeleted: false,
        isNewItem: true,
      });
      console.log(this.selectedItems);
    },

    /**
     * if the item is newly added, remove it completely from the selectedItems array.
     * othwerwise just mark it as deleted
     * */
    deleteFromSelectedItems(index) {
      this.selectedItems[index].isDeleted = true;
      if (this.selectedItems[index].isNewItem) this.selectedItems.splice(index, 1);
    },

    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */

    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(
        ({ journalUuid, isDeleted }) => isDeleted || journalUuid,
      );
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.journalUuid),
      );
    },

    formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getDate(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD');
      } else {
        return null;
      }
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>
